/**
 * Enum para los diferentes estados de "No hay seguro"
 * Cada estado tiene un código numérico asociado
 */
export enum NoHaySeguroEstado {
  /** En este momento no podemos asegurar tu moto - marca línea no permitida */
  MARCA_LINEA_NO_PERMITIDA = 50,
  
  /** En este momento no podemos asegurar tu moto - zona de circulación */
  ZONA_CIRCULACION = 52,
  
  /** En este momento no podemos asegurar tu moto - falla tarifa */
  FALLA_TARIFA = 100,

  /** En este momento no podemos asegurar tu moto - falla tarifa */
  RIESGOS_CONSULTABLES = 51
}

/**
 * Mapeo de códigos a descripciones legibles
 */
export const NoHaySeguroDescripciones: Record<NoHaySeguroEstado, string> = {
  [NoHaySeguroEstado.MARCA_LINEA_NO_PERMITIDA]: 'En este momento no podemos asegurar tu moto - marca linea no permitida',
  [NoHaySeguroEstado.ZONA_CIRCULACION]: 'En este momento no podemos asegurar tu moto - zona de circulación',
  [NoHaySeguroEstado.FALLA_TARIFA]: 'En este momento no podemos asegurar tu moto - falla tarifa',
  [NoHaySeguroEstado.RIESGOS_CONSULTABLES]: 'En este momento no podemos asegurar tu moto - riesgos consultables'
};
